"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const account_1 = require("../../account");
const api_1 = require("./api");
const js_transaction_1 = require("./js-transaction");
/**
 * Returns the maximum possible amount for transaction
 *
 * @param {Object} param - the account, parentAccount and transaction
 */
const estimateMaxSpendable = ({ account, parentAccount, transaction, }) => __awaiter(void 0, void 0, void 0, function* () {
    const mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
    const tx = Object.assign(Object.assign(Object.assign(Object.assign({}, (0, js_transaction_1.createTransaction)()), { subAccountId: account.type === "Account" ? null : account.id }), transaction), { useAllAmount: true });
    const tokenAccount = tx.subAccountId &&
        mainAccount.subAccounts &&
        mainAccount.subAccounts.find(ta => ta.id === tx.subAccountId);
    if (tokenAccount) {
        return tokenAccount.balance;
    }
    const fees = yield (0, api_1.getFees)(tx);
    if (fees.gt(mainAccount.spendableBalance)) {
        return new bignumber_js_1.BigNumber(0);
    }
    return mainAccount.spendableBalance.minus(fees);
});
exports.default = estimateMaxSpendable;
//# sourceMappingURL=js-estimateMaxSpendable.js.map